<template>

  <div>

    <t-msg info v-if="categoryUnique === ''">Informe se deseja que
      <span v-if="typeImage"> as imagens </span>
      <span v-else> os arquivos </span>
      fiquem disponíveis publicamente através do link URL deste local, alterando a categoria para: Público.<br />Somente funciona se habilitado a opção de URL do local.
    </t-msg>

    <t-msg info v-if="categoryUnique !== ''">Insira a planta baixa por pavimento para marcar os apontamentos (podendo ser por ambiente, porém através do formulário do ambiente). Caso deixar público estará disponível através do QR code que também deverá estar habilitado para exibição via URL.</t-msg>

    <t-page-form-upload
        :type-image="typeImage"
        :type-unique-image="typeUniqueImage"
        :type-unique-doc="typeUniqueDoc"
        :command="command"
        :other-entity="otherEntity"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.spotFolderFileId" :foreign-key="form.spotFolderId"
        :items="items" :user-auth="userAuth" :status="status"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :category-options="SharingFileType.list"
        :category-unique="categoryUnique" :detail-unique="detailUnique"
        :category-id="SharingFileType.type.RESTRICT"
        category-column="sharingFileType"
        :message-not-record="messageNotRecord"
        :only-view="onlyView"
        @onSubmit="onSubmit" @itemDownload="onItemFileDownload" @onItemDelete="onItemDeleteDefault"
        @onUploadComplete="onUploadComplete" @onRequestList="getList">

    </t-page-form-upload>

  </div>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormUploadMixin from "@/mixins/page/pageFormUploadMixin";
import tPageFormUpload from "@/components/template/page/t-page-form-upload";
import SharingFileType from "@/model/types/resource/SharingFileType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormUploadMixin],
  components: {tPageFormUpload},
  name: 'SpotFolderFile',
  data() {
    return {
      SharingFileType,
      path: "place/spot-folder-file", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "spotFolderFileId",
      foreignKeyColumn: "spotFolderId", //Utilizar quando usar Tabs com outros componentes
      type: "D", //Tipo padrão de modelo de envio de arquivos poderá ser I ou D
      form: {
        spotFolderId: this.foreignKey,
        spotFolderFileId: 0,
        orderList: 0,
        type: "",
        fileEntity: {
          nameOriginal: "",
          nameSave: "",
          sizeKb: 0,
          extension: "",
        }
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    otherEntity: Boolean,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      if (this.otherEntity) {
        this.command = 'view'
      }

      this.mountedPrepareFormUploadDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.spotFolderFileId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
